import { render } from "./filters.vue?vue&type=template&id=d16b6904&ts=true&lang=pug"
import script from "./filters.vue?vue&type=script&setup=true&lang=ts"
export * from "./filters.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__